import { api } from './requestGraphql';

const getAffiliateNews = async (pagination, sorting, filters) => {

    let preparedFilters = '';

    for (const filter in filters) {
        preparedFilters += (!!filters[filter]) ?
            `${filter}: "${filters[filter]}"` : '';
    }

    try {
        const res = await api.post(
            '', {
                query: `
                {
                    getAffiliateNews(
                        pagination: { page: ${pagination.page}, limit: ${pagination.limit} }, 
                        sorting: { orderBy: "${sorting.orderBy}", orderDirectionAsc: ${sorting.orderDirectionAsc} }
                        filters: { ${preparedFilters} }
                    ) {
                        count
                        data {
                            id
                            headline
                            news
                            status
                            publishedOn
                            lastUpdatedOn
                            lastUpdatedBy
                        }
                    }
                }
                `,
            }
        );

        let response = res.data.data.getAffiliateNews;
        // console.log(`getAffiliateAlerts response:`, response);
        return response;
    } catch (e) {
        console.error(e);
    }
};

const getAffiliateNewsFilterData = async () => {
    try {
        const res = await api.post('', {
            query: `
                {
                    getAffiliateNewsFilterData {
                        filters {
                            id {
                                key
                                value
                            }
                            headline {
                                key
                                value
                            }
                            news {
                                key
                                value
                            }
                            status {
                                key
                                value
                            }
                            lastUpdatedBy {
                                key
                                value
                            }
                        }
                    }
                }
            `,
        });

        let response = res.data.data.getAffiliateNewsFilterData;
        // console.log(`getAffiliateAlertsFilterData response:`, response);
        return response;
    } catch (e) {
        console.error(e);
    }
};

const createNews = async (data) => {
    const headline = btoa(data.headline);
    const news = btoa(data.news);
    try {
        const res = await api.post('', {
            query: `
               mutation {
                  createOrUpdateAffiliateNews(data: {
                    id: ${data.id}
                    news: "${news}",
                    headline: "${headline}",
                    status: "${data.status}",
                    isEdit: ${data.isEdit}
                  }) {
                    news
                    headline
                    status
                    id
                    lastUpdatedOn
                    publishedOn
                    lastUpdatedBy
                  }
               }
            `,
        });

        let response = res.data.data.createOrUpdateAffiliateNews;
        // console.log(`getAffiliateAlertsFilterData response:`, response);
        return response;
    } catch (e) {
        console.error(e);
    }
};

const getAffiliateNewsHistoryById = async (id) => {
    try {
        const res = await api.post('', {
            query: `
                {
                    getAffiliateNewsHistoryById(id: ${id}) {
                        entity
                        user
                        action
                        dateAdded
                        logs
                    }
                }
            `,
        });

        return res.data.data.getAffiliateNewsHistoryById;
    } catch (e) {
        console.error(e);
        throw e;
    }
};

export default {
    getAffiliateNews,
    getAffiliateNewsFilterData,
    createNews,
    getAffiliateNewsHistoryById
}
